/*
 *  Product Accordions
 *    Scripts for accordions
 *
 *  Version:
 *    1.0.0 - 2022/02/05
 */

import { initAccordion } from '../../objects/accordion/accordion';

// Selectors
const SELECTOR_CONTAINER = '[data-product-accordions]';

document
  .querySelectorAll<HTMLElement>(SELECTOR_CONTAINER)
  .forEach((container) => {
    initAccordion({ container });
  });
